import React from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import config from '../config.js'

import {fetchDataIfReady} from 'Skelet/src/modules/fetch.action.js'
import {handleChange} from 'Skelet/src/modules/functions.js'
import ModalWrapper from 'Skelet/src/components/Modal_Wrapper.js'


class ModalCreateFoodlog extends React.Component {

  constructor(props) {
    super(props);

    let now = new Date();
    let date = now.getFullYear()+"-"+('0'+(now.getMonth()+1)).slice(-2)+"-"+('0'+now.getDate()).slice(-2);
    this.state = {food_id:"", food_grams:"", date, getbyurl_store:"", getbyurl_url:""};
  }

  render() {
    if(this.props.shouldShow) {
      const submit_disabled = this.state.food_id.trim() === "" || this.state.food_grams.trim() === "" || this.state.date.trim() === "";
      const submit_disabled2 = this.state.getbyurl_url.trim() === "" || !this.state.getbyurl_url.startsWith("https://www.ah.nl/");
      const {food_list} = this.props;

      let select = null;
      if(food_list) {
        let select_options = [<option key={"defaultO"} value="">selecteer product..</option>];

        let sorted = food_list.sort((a, b) => {
          let ia = a.name.toLowerCase()+"-"+a.brand.toLowerCase(),
          ib = b.name.toLowerCase()+"-"+b.brand.toLowerCase();
          if(ia < ib) return -1;
          if(ia > ib) return 1;
          return 0;
        });

        for(let i = 0; i < sorted.length; i++) {
          var o = sorted[i];
          select_options.push(<option key={"o"+i} value={o.id}>{o.name} - {o.brand}</option>);
        }
        select = <select value={this.state.food_id} onChange={(e) => handleChange(this, "food_id", e)} autoFocus>{select_options}</select>
      }

      return (
        <ModalWrapper switchState={this.props.close}>
          <form onSubmit={(e) => {e.preventDefault();this.submitForm()}}>
            <div>{select}</div>
            <div><input type="text" value={this.state.food_grams} onChange={(e) => handleChange(this, "food_grams", e)} maxLength="4" placeholder="Aantal gram/ml" /></div>
            <div><input type="date" value={this.state.date} onChange={(e) => handleChange(this, "date", e)} maxLength="10" placeholder="2021-12-30" /></div>
            <div><input type="submit" value="toevoegen" disabled={submit_disabled} /></div>
          </form>
          <form onSubmit={(e) => {e.preventDefault();this.submitFormGetByURL()}}>
            <div style={{fontSize:"95%"}}><br/><br/><hr style={{border:"1px solid #279bea"}}/>Staat je product er niet bij? Vul hier de URL in van het product op AH.nl, zoals:<br/><span style={{opacity:".8", fontSize:"85%"}}>https://www.ah.nl/producten/product/wi437258/yakult-original</span></div>
            <div><input type="text" value={this.state.getbyurl_url} onChange={(e) => handleChange(this, "getbyurl_url", e)} maxLength="400" placeholder="Product URL" /></div>
            <div><input type="submit" value="opzoeken" disabled={submit_disabled2} /></div>
          </form>
        </ModalWrapper>
      );
    } else {
      return null;
    }
  }

  submitForm() {
    const {food_id, food_grams, date} = this.state;
    const submit_disabled = food_id.trim() === "" || food_grams.trim() === "" || date.trim() === "";
    if(!submit_disabled) {
      this.props.fetchDataIfReady(config.api_token, "bin", "POST", config.api_url+"/foodlog", JSON.stringify({session_token:this.props.session_token, food_id, food_grams, date}), null, true, false, true, false, false, null, "foodlog_list");
      this.props.close();
      this.setState({food_id:"", food_grams:"", date:""});
    }
  }

  submitFormGetByURL() {
    const {getbyurl_url} = this.state;
    const submit_disabled = getbyurl_url.trim() === "";
    if(!submit_disabled) {
      this.props.fetchDataIfReady(config.api_token, "bin", "POST", config.api_url+"/get-food", JSON.stringify({session_token:this.props.session_token, url:getbyurl_url}), null, true, false, true, false, false, null, "food_list");
      this.setState({getbyurl_url:""});
    }
  }

}


function mapStateToProps(state) {
  let session_token = null, food_list = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  if(state.apiData["food_list"] !== undefined && state.apiData["food_list"]["data"][0] !== undefined) {
    food_list = state.apiData["food_list"]["data"];
  }
  return {
    session_token: session_token,
    food_list: food_list,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreateFoodlog)



// WEBPACK FOOTER //
// ./src/containers/ModalCreateFoodlog.js